import { SupplierTemplateWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: SupplierTemplateWebService.Configuration
});

export default config;
